import { Observable } from 'rxjs/Observable';
import { IDelegationRequest, IUserIDRequest } from './http-requests';
import { AppEndpoints } from '../app.endpoints';
import { MetaData } from '../../globals/classes/urlBuilder';
import { HttpService } from '../../globals/providers/http.service';
import { ISendSmsOtpResponse } from './http-responses';
import { AppSettings } from '../app.settings';

export interface IInitializePasswordRequest {
	userID: string;
	passwordNew: string;
	passwordConfirmNew: string;
	otp: string;
	updateUser: string;
	channel: string;
}

export class InitializePasswordRequest implements IInitializePasswordRequest {
	public userID: string;
	public passwordNew: string;
	public passwordConfirmNew: string;
	public otp: string;
	public updateUser: string;
	public channel: string;

	constructor(initPass?: IInitializePasswordRequest) {
		let newInitPass: IInitializePasswordRequest = initPass || {
			channel: null,
			otp: null,
			passwordNew: null,
			passwordConfirmNew: null,
			updateUser: null,
			userID: null,
		};
		this.read(newInitPass);
	}

	private read(newInitPass: IInitializePasswordRequest) {
		this.channel = newInitPass.channel;
		this.otp = newInitPass.otp;
		this.passwordNew = newInitPass.passwordNew;
		this.passwordConfirmNew = newInitPass.passwordConfirmNew;
		this.userID = newInitPass.userID;
		this.updateUser = newInitPass.updateUser;
	}
}

export interface IInitializePasswordResponse {
	succeeded: boolean;
	wasToken: string;
	sessionToken: string;
	actualUserId: string;
	loginError: string;
	systemErrorMsg: string;
}

export class InitializePassword {
	/* Delegate Request */
	public static initializePassword(
		request: IInitializePasswordRequest
	): Observable<IInitializePasswordResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<IInitializePasswordResponse>(
				AppEndpoints.initializePassword,
				request
			);
		} else {
			return InitializePassword.useDelegateRequestInitializePassword(
				AppEndpoints.initializePassword,
				request
			);
		}
	}

	/* Delegate Request */
	public static SendInitOtpPass(request: IUserIDRequest): Observable<ISendSmsOtpResponse> {
		if (AppSettings.skipDelegationRequest) {
			return HttpService.post<ISendSmsOtpResponse>(AppEndpoints.sendInitPass, request);
		} else {
			return InitializePassword.useDelegateRequestSendInitOtpPass(
				AppEndpoints.sendInitPass,
				request
			);
		}
	}
	/* SendInitOtpPass */
	private static useDelegateRequestSendInitOtpPass(
		endPointUrl: string,
		request: IUserIDRequest
	): Observable<ISendSmsOtpResponse> {
		return HttpService.post<ISendSmsOtpResponse>(
			AppEndpoints.delegateRequest,
			InitializePassword.setDelegationRequest(endPointUrl, request),
			false
		);
	}

	/* initializePassword */
	private static useDelegateRequestInitializePassword(
		endPointUrl: string,
		request: IInitializePasswordRequest
	): Observable<IInitializePasswordResponse> {
		return HttpService.post<IInitializePasswordResponse>(
			AppEndpoints.delegateRequest,
			InitializePassword.setDelegationRequest(endPointUrl, request),
			false
		);
	}

	private static setDelegationRequest(endPointUrl: string, request: any): IDelegationRequest {
		return {
			audiences: 'LoginApi',
			endPointUrl: endPointUrl,
			body: new MetaData().wrap2Request(request),
		};
	}
}
